module.exports = __webpack_public_path__ + "static/media/grey-clouds.c1a1a087.webp";